import { render, staticRenderFns } from "./DeportDailyStore.vue?vue&type=template&id=caa4ef8e&scoped=true&"
import script from "./DeportDailyStore.vue?vue&type=script&lang=js&"
export * from "./DeportDailyStore.vue?vue&type=script&lang=js&"
import style0 from "./DeportDailyStore.vue?vue&type=style&index=0&id=caa4ef8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa4ef8e",
  null
  
)

export default component.exports